// src/FeedbackModal.jsx
import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Typography
} from '@mui/material';

export default function FeedbackModal({ open, onClose }) {
    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [cumpriuExpectativa, setCumpriuExpectativa] = useState('');
    const [comentarios, setComentarios] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Auto-fill nome and email from localStorage when modal opens
    useEffect(() => {
        if (open) {
            setNome(localStorage.getItem('feedback_nome') || '');
            setEmail(localStorage.getItem('feedback_email') || '');
        }
    }, [open]);

    // Get sessionId from localStorage
    const sessionId = localStorage.getItem('n8n-chat/sessionId') || '';

    const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);

    const isFormValid = () => {
        // Nome, Email and Comentários are required.
        return (
            nome.trim() !== '' &&
            email.trim() !== '' &&
            isValidEmail(email) &&
            comentarios.trim() !== ''
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isFormValid()) return;
        setSubmitting(true);

        // Save nome and email in localStorage
        localStorage.setItem('feedback_nome', nome);
        localStorage.setItem('feedback_email', email);

        const payload = {
            nome,
            email,
            sessionId,
            cumpriuExpectativa,
            comentarios
        };

        try {
            const response = await fetch('https://dev.api.foxid.com.br/webhook/f7f6c2db-bc27-49f0-84c0-fc897e932ea4', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });
            if (!response.ok) {
                throw new Error('Erro ao enviar feedback.');
            }
            setSubmitted(true);
        } catch (error) {
            console.error(error);
            // Optionally display an error message
        } finally {
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        // Reset form on close
        setNome('');
        setEmail('');
        setCumpriuExpectativa('');
        setComentarios('');
        setSubmitted(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm" sx={{zIndex: 10000}}>
            <DialogTitle>Formulário de Feedback</DialogTitle>
            <DialogContent>
                {submitted ? (
                    <Typography variant="h6" align="center" sx={{ mt: 2 }}>
                        Obrigado pelo seu feedback!
                    </Typography>
                ) : (
                    <form id="feedback-form" onSubmit={handleSubmit}>
                        <TextField
                            label="1. Nome"
                            value={nome}
                            onChange={(e) => setNome(e.target.value)}
                            required
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputProps={{ style: { borderRadius: '8px' } }}
                        />
                        <TextField
                            label="2. Email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputProps={{ style: { borderRadius: '8px' } }}
                            error={email && !isValidEmail(email)}
                            helperText={email && !isValidEmail(email) ? 'Email inválido' : ''}
                        />
                        <FormControl component="fieldset" margin="normal">
                            <FormLabel component="legend">
                                3. Em uma escala de 1 a 5, quanto o ChatBOT ABES cumpriu suas expectativas?
                            </FormLabel>
                            <RadioGroup
                                row
                                value={cumpriuExpectativa}
                                onChange={(e) => setCumpriuExpectativa(e.target.value)}
                            >
                                {[1, 2, 3, 4, 5].map((num) => (
                                    <FormControlLabel
                                        key={num}
                                        value={num.toString()}
                                        control={<Radio />}
                                        label={num.toString()}
                                    />
                                ))}
                            </RadioGroup>
                        </FormControl>
                        <TextField
                            label="4. O ChatBOT forneceu respostas incorretas? Comente abaixo (campo obrigatório)"
                            value={comentarios}
                            onChange={(e) => setComentarios(e.target.value)}
                            required
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            multiline
                            rows={4}
                            InputProps={{
                                style: {
                                    borderRadius: '8px',
                                    whiteSpace: 'pre-wrap' // Ensure text wraps
                                }
                            }}
                        />
                    </form>
                )}
            </DialogContent>
            {!submitted && (
                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button
                        type="submit"
                        form="feedback-form"
                        variant="contained"
                        disabled={!isFormValid() || submitting}
                        sx={{
                            backgroundColor: (!isFormValid() || submitting) ? 'gray' : 'primary.main',
                            border: 'solid 1px var(--chat--color-light-shade-50)',
                            borderRadius: '8px',
                            textTransform: 'none'
                        }}
                    >
                        Enviar Feedback
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
}
